import { computed, ref } from 'vue';
import {
  AroonOscillatorCalculator,
  BollingerBandPositionCalculator,
  BollingerBandWidthCalculator,
  Calculator,
  FullStochasticsCalculator,
  PercentagePerformanceCalculator,
  PercentagePriceOscillatorCalculator,
  RelativeStrengthIndexCalculator,
  StochasticRelativeStrengthIndexCalculator,
  StockChartsTechnicalRankCalculator,
  UpDaysDownDaysCalculator
} from '@/ts/map/calculationFunctions';

const CALCULATOR_MAP = {
  'performance': new PercentagePerformanceCalculator(),
  'sctr': new StockChartsTechnicalRankCalculator(),
  'updown': new UpDaysDownDaysCalculator(),
  'rsi': new RelativeStrengthIndexCalculator(),
  'ppo': new PercentagePriceOscillatorCalculator(),
  'bbwidth': new BollingerBandWidthCalculator(),
  'bbposition': new BollingerBandPositionCalculator(),
  'stochrsi': new StochasticRelativeStrengthIndexCalculator(),
  'aroon': new AroonOscillatorCalculator(),
  'fullstoch': new FullStochasticsCalculator()
};

type CalculatorKey = keyof typeof CALCULATOR_MAP;

function isValidMeasurement(value: string): value is CalculatorKey {
  return Object.keys(CALCULATOR_MAP).includes(value);
}

const DEFAULT_CALCULATOR: CalculatorKey = 'performance';

// Factory for creating instance-scoped calculator state
export function createCalculator(options?: { calculator?: CalculatorKey }) {
  const calculatorKey = ref<CalculatorKey>(options?.calculator ?? DEFAULT_CALCULATOR);
  const calculator = computed<Calculator>(() => CALCULATOR_MAP[calculatorKey.value]);
  return { calculatorKey, calculator };
}

export type { CalculatorKey };

export {
  DEFAULT_CALCULATOR,
  isValidMeasurement
};
